import React from 'react';
import { ThemeProvider } from './theme/ThemeProvider';
import HomePage from './components/pages/HomePage';

function App() {
  return (
    <ThemeProvider>
      <HomePage />
    </ThemeProvider>
  );
}

export default App;
